function mapearBalanceComprobacion(datos) {
  const mapa = datos.reduce((acc, item, index) => {
    acc[item.IdentificadorCuenta] = {
      data: { ...item },
      children: [],
      key: `${index}`,
    };
    return acc;
  }, {});

  const salida = datos.reduce((acc, item) => {
    if (item.CuentaPadre === null || item.CuentaPadre === 0) {
      acc.push(mapa[item.IdentificadorCuenta]);
    } else {
      if (mapa[item.CuentaPadre]) {
        mapa[item.CuentaPadre].children = [...mapa[item.CuentaPadre].children, mapa[item.IdentificadorCuenta]];
      }
    }
    return acc;
  }, []);

  function assingKeys(clavePadre, children) {
    return children.map((child, index) => {
      const newKey = `${clavePadre}-${index}`;
      const newNodo = {
        ...child,
        key: newKey,
        children: child.children.length > 0 ? assingKeys(newKey, child.children) : [],
      };

      if (newNodo.children.length > 0) {
        return agregarTotal(newNodo, newKey);
      }

      return newNodo;
    });
  }

  return salida.map((item, index) => {
    const newKey = `${index}`;
    return agregarTotal(
      {
        ...item,
        key: newKey,
        children: assingKeys(newKey, item.children),
      },
      newKey
    );
  });
}

function agregarTotal(nodo, key) {
  if (nodo.data.IdentificadorCuenta === "Total") {
    return nodo;
  }

  const total = {
    data: {
      IdentificadorCuenta: "Subtotal",
      CuentaDesc: `TOTAL ${nodo.data.Nombre}`,
      DebitoPeriodoAnterior: nodo.data.DebitoPeriodoAnterior,
      CreditoPeriodoAnterior: nodo.data.CreditoPeriodoAnterior,
      DebitoPeriodoActual: nodo.data.DebitoPeriodoActual,
      CreditoPeriodoActual: nodo.data.CreditoPeriodoActual,
      DebitoAcumulado: nodo.data.DebitoAcumulado,
      CreditoAcumulado: nodo.data.CreditoAcumulado,
      balance: {
        debito: nodo.data.balance.debito,
        credito: nodo.data.balance.credito,
      },
    },
    key: `total-${key}`,
    children: [],
  };
  return { ...nodo, children: [...nodo.children, total] };
}

export default mapearBalanceComprobacion;
